import React from "react";
import {Link} from 'react-router-dom';

const SERVICES = [
	{
		icon: 'fa-building-o',
		title: 'Genel Bina Yönetimi',
		text: 'Gelir-gider hesapları, defter tutma, personel bordro/SGK işlemleri, genel kurul hazırlığı ve teknik bakım koordinasyonu — tek elden.',
	},
	{
		icon: 'fa-line-chart',
		title: 'Bütçe Yönetimi',
		text: 'Aidat bütçeniz uzman hesap kadromuzca planlanır; harcamalar bütçeye uygun gerçekleşip gerçekleşmediği daimî kontrol altında tutulur.',
	},
	{
		icon: 'fa-users',
		title: 'Taşeron Hizmet Yönetimi',
		text: 'Muhasebe, teknik, güvenlik, temizlik, peyzaj ve ilaçlama birimleri görev tanımına uygun yönetilerek tesisinizin değeri yükseltilir.',
	},
];

const Services = () => {
	return (
		<section className='services' id='hizmetler'>
			<div className='services-inner'>
				<div className='services-header'>
					<span className='section-eyebrow'>Hizmetlerimiz</span>
					<h2 className='section-title'>Profesyonel yönetim hizmetleri</h2>
					<p className='section-lead'>
						Site ve apartmanlarınız için ihtiyaç duyduğunuz tüm
						operasyonel ve finansal süreçleri tek çatı altında topluyoruz.
					</p>
				</div>
				<div className='card-cont'>
					{SERVICES.map((s) => (
						<article className='card' key={s.title}>
							<div className='card-icon'>
								<i className={`fa ${s.icon}`} aria-hidden='true'></i>
							</div>
							<h3 className='card-title'>{s.title}</h3>
							<p className='card-text'>{s.text}</p>
							<div className='card-foot'>
								<Link to='/hizmetlerimiz' className='btn-link'>Detaylı bilgi</Link>
							</div>
						</article>
					))}
				</div>
				<div className='button-container'>
					<Link to='/hizmetlerimiz' className='btn btn-primary'>
						Tüm hizmetleri gör
					</Link>
				</div>
			</div>
		</section>
	);
};

export default Services;
